import React from "react";

export default function Container({ className = "", as: Tag = "div", children, ...rest }) {
  return (
    <Tag className={`mx-auto w-full max-w-[90rem] px-4 sm:px-6 lg:px-10 xl:px-16 ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
